<template>
  <v-btn
    v-bind="attrs"
    :flat="flat"
    :outline="outline"
    :icon="!text && Boolean(icon)"
    :color="color"
    :round="round"
    :loading="loading"
    :disabled="disabled"
    @click="$emit('click', this)">
    <v-icon
      v-if="icon && !icon.right"
      v-bind="icon"
      v-text="icon.text" />
    {{ text }}
    <v-icon
      v-if="icon && icon.right"
      v-bind="icon"
      v-text="icon.text" />
  </v-btn>
</template>
<script>

export default {
  props: {
    attrs: {
      type: Object,
      default: null
    },
    component: {
      type: [String, Object],
      default: () => 'v-btn'
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    disabled: Boolean,
    flat: Boolean,
    icon: {
      type: Object,
      default: null
    },
    loading: Boolean,
    outline: Boolean,
    round: Boolean
  }
}
</script>
